////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useForm } from 'react-hook-form'
///////COMPONENTS///////
import theme from '../../theme/theme'
import LoadingInLine from '../LoadingInLine'
import Button from '../Ui/Buttons'
/////////ASSETS/////////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ForgotPasswordWrapper = styled.div`
	max-width: 555px;
`
const FormWrapper = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`
const InputWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 10px;
`
const InputLogin = styled.input`
	height: 45px;
	width: 195px;
	border-radius: 3px;
	border: 1px solid ${(props) => props.theme.colors.cancel};
	padding-left: 5px;
	box-sizing: border-box;
	font-family: Lato;
	font-size: 14px;
	:focus {
		outline: none !important;
		border-color: ${(props) => props.theme.colors.primary};
	}
	:-webkit-autofill,
	:-webkit-autofill:hover,
	:-webkit-autofill:focus,
	:-webkit-autofill:active {
		transition: background-color 5000s ease-in-out 0s;
		box-shadow: 0 0 0px 1000px ${(props) => props.theme.colors.white} inset;
	}
`
const ErrorFormMsg = styled.p`
	text-align: center;
	color: ${(props) => props.theme.colors.error};
`
const ButtonWrapper = styled.div`
	width: 100%;
	height: 40px;
	margin-top: 52px;
	display: flex;
	justify-content: space-between;
`
const ErrorInputMsg = styled.div`
	position: absolute;
	left: 280px;
	width: max-content;
	color: ${(props) => props.theme.colors.error};
`
const TextModalSuccess = styled.div`
	color: ${(props) => props.theme.colors.validation};
	margin: 0;
	padding: 15px 0;
`
const TextModal = styled.div`
	margin: 0;
	padding: 15px 0;
	color: ${(props) => props.color || 'inherit'};
`
const TextForgotLogin = styled.p`
	color: ${(props) => props.theme.colors.cancel};
	font-size: ${(props) => props.theme.font.fs};
	cursor: pointer;
	text-decoration: underline;
`
const QuestionMarkWrapper = styled.img`
	height: 15px;
	width: 15px;
	margin-left: 7px;
`
/////////STYLED/////////

const ForgotPassword = ({ passwordToUser, translations, closeModalHandler, handleForgotPassword, usrForgotpw, disabledButton }) => {
	const { register, handleSubmit, errors } = useForm()

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ForgotPasswordWrapper>
			<FormWrapper onSubmit={handleSubmit(handleForgotPassword)}>
				<TextModal color={theme.colors.primary}>
					{translations['page__login__forgotPassword_modal_subtitle']}
					{/* <QuestionMarkWrapper src={QuestionMark} /> */}
				</TextModal>

				{usrForgotpw.status !== 0 &&
					(usrForgotpw.status === 200 ? (
						<TextModalSuccess>{translations['modal__forgotPassword__modalSuccess_body']}</TextModalSuccess>
					) : (
						<ErrorFormMsg>{translations['modal__error404__body']}</ErrorFormMsg>
					))}

				<LoadingInLine isLoading={usrForgotpw.isLoading} translations={translations} />

				<InputWrapper>
					<InputLogin
						name="forgotPw"
						type="text"
						ref={register({
							required: {
								value: true,
								message: translations['common__text__requiredField'],
							},
							maxLength: {
								value: 150,
								message: '',
							},
						})}
					/>
					{errors.forgotPw && <ErrorInputMsg>{errors.forgotPw.message}</ErrorInputMsg>}
				</InputWrapper>
				<TextModal>{translations['page__login__forgotPassword_modal_info']}</TextModal>
				<TextForgotLogin onClick={passwordToUser}>{translations['page__login__forgotUsername']}</TextForgotLogin>
				<ButtonWrapper>
					<Button bgColor={theme.colors.error} actionHandler={closeModalHandler} img={Cancel} text={translations['common__text__cancel']} />
					<Button
						bgColor={theme.colors.validation}
						type="submit"
						img={Validation}
						text={translations['common__text__validate']}
						disabled={disabledButton}
					/>
				</ButtonWrapper>
			</FormWrapper>
		</ForgotPasswordWrapper>
	)
}

ForgotPassword.propTypes = {}

ForgotPassword.defaultPropTypes = {}

export default ForgotPassword
